// Values based on code from https://github.com/spatialillusions/milsymbol-generator

export const AIR_SYMBOLSET_VALUE = "01";
export const MISSILE_SYMBOLSET_VALUE = "02";
export const SPACE_SYMBOLSET_VALUE = "05";
export const UNIT_SYMBOLSET_VALUE = "10";
export const CIVILIAN_SYMBOLSET_VALUE = "11";
export const EQUIPMENT_SYMBOLSET_VALUE = "15";
export const INSTALLATION_SYMBOLSET_VALUE = "20";
export const CONTROLMEASURE_SYMBOLSET_VALUE = "25";
export const DISMOUNTED_SYMBOLSET_VALUE = "27";
export const SURFACE_SYMBOLSET_VALUE = "30";
export const SUBSURFACE_SYMBOLSET_VALUE = "35";
export const MINE_SYMBOLSET_VALUE = "36";
export const ACTIVITY_SYMBOLSET_VALUE = "40";

export const contextValues = [
	{ value: "0", label: "Reality" },
	{ value: "1", label: "Exercise" },
	{ value: "2", label: "Simulation" },
];

export const sidValues = [
	{ value: "0", label: "Pending" },
	{ value: "1", label: "Unknown" },
	{ value: "2", label: "Assumed Friend" },
	{ value: "3", label: "Friend" },
	{ value: "4", label: "Neutral" },
	{ value: "5", label: "Suspect/Joker" },
	{ value: "6", label: "Hostile/Faker" },
];

export const HQTFDummyValues = [
	{ value: "0", label: "Not Applicable" },
	{ value: "1", label: "Feint/Dummy" },
	{ value: "2", label: "Headquarters" },
	{ value: "3", label: "Feint/Dummy Headquarters" },
	{ value: "4", label: "Task Force" },
	{ value: "5", label: "Feint/Dummy Task Force" },
	{ value: "6", label: "Task Force Headquarters" },
	{ value: "7", label: "Feint/Dummy Task Force Headquarters" },
];

export const statusValues = [
	{ value: "0", label: "Present" },
	{ value: "1", label: "Planned/Anticipated/Suspect" },
	{ value: "2", label: "Present/Fully capable" },
	{ value: "3", label: "Present/Damaged" },
	{ value: "4", label: "Present/Destroyed" },
	{ value: "5", label: "Present/Full to capacity" },
];

export const echelonValues = [
	{ value: "00", label: "Unspecified" },
	{ value: "11", label: "Team/Crew" },
	{ value: "12", label: "Squad" },
	{ value: "13", label: "Section" },
	{ value: "14", label: "Platoon/Detachment" },
	{ value: "15", label: "Company/Battery/Troop" },
	{ value: "16", label: "Battalion/Squadron" },
	{ value: "17", label: "Regiment/Group" },
	{ value: "18", label: "Brigade" },
	{ value: "21", label: "Division" },
	{ value: "22", label: "Corps/MEF" },
	{ value: "23", label: "Army" },
	{ value: "24", label: "Army Group/Front" },
	{ value: "25", label: "Region/Theater" },
	{ value: "26", label: "Command" },
];

export const mobilityValues = [
	{ value: "00", label: "Unspecified" },
	{ value: "31", label: "Wheeled limited cross country" },
	{ value: "32", label: "Wheeled cross country" },
	{ value: "33", label: "Tracked" },
	{ value: "34", label: "Wheeled and tracked combination" },
	{ value: "35", label: "Towed" },
	{ value: "36", label: "Railway" },
	{ value: "37", label: "Pack animals" },
	{ value: "41", label: "Over snow (prime mover)" },
	{ value: "42", label: "Sled" },
	{ value: "51", label: "Barge" },
	{ value: "52", label: "Amphibious" },
];

export const leadershipValues = [
	{ value: "00", label: "Unspecified" },
	{ value: "71", label: "Leader" },
];

export const towedArrayValues = [
	{ value: "00", label: "Unspecified" },
	{ value: "61", label: "Short towed array" },
	{ value: "62", label: "Long towed array" },
];
